import classNames from 'classnames';
import styles from './Link.module.scss';
import { useRouteContext } from 'ui/contexts/RouteContext';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import type { IconProps } from 'ui/components/1-atoms/Media/Icon/Icon';

export interface LinkProps {
	children?: React.ReactNode;
	style?: 'primary' | 'sm';
	id?: string;
	className?: string;
	url: string;
	target?: string;
	title?: string;
	rel?: string;
	ariaLabel?: string;
	clickHandler?: (event: React.MouseEvent) => void;
	disableRouteHandler?: boolean; // Set to true if you want to handle routing manually
	locale?: string | boolean;
	showIcon?: boolean;
	icon?: React.ReactNode;
	iconPlacement?: 'left' | 'right';
	iconSize?: IconProps['size'];
	iconStyle?: IconProps['style'];
	download?: string;
}

export const UI_Link = ({
	children,
	style,
	id,
	className,
	url,
	target,
	title,
	rel,
	ariaLabel,
	clickHandler,
	disableRouteHandler,
	locale,
	showIcon,
	icon,
	iconPlacement = 'left',
	iconSize = 'md',
	iconStyle,
	download,
}: LinkProps) => {
	const { routeHandler } = useRouteContext() || {};

	return (
		<a
			id={id}
			className={classNames(styles.Link, styles[`Link___${style}`], showIcon && styles.Link___icon, className)}
			href={url}
			target={target}
			title={title}
			rel={rel}
			onClick={(event) => {
				if (clickHandler) clickHandler(event);
				if (!disableRouteHandler && url && routeHandler) routeHandler(event, url, locale, target);
			}}
			aria-label={ariaLabel}
			download={download}
		>
			{showIcon && (
				<UI_Icon style={iconStyle} size={iconSize} className={classNames(styles.Link_icon, styles[`Link_icon___${iconPlacement}`])}>
					{icon}
				</UI_Icon>
			)}
			{children}
		</a>
	);
};
